import {kSystemIcons} from "../../constants/icons";


export default function SystemModalClosingCrossIcon({onIconPress}) {
    // Used through the app and especially in dialogs to show
    // a closing modal/dialog cross icon

    // BUILD
    return(
        <div className={"flex"}
             onClick={() => onIconPress()}>
            <i className={`material-icons cursor-pointer text-[24px] text-greyLight7 hover:text-greyLight9`}>
                {kSystemIcons.cancel}
            </i>
        </div>
    );
}